import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

class Loader extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return <div className="Panel-loader" />;
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./frontend/src/js/components/loader/Loader.jsx